import Swiper, { Thumbs } from "swiper";
Swiper.use([Thumbs]);

export default class Main {
    constructor() {
        this.init();
    }

    init() {
        this.setSwiper();
    }

    setSwiper() {
        //length1の時はswiper要素は出現しない

        const thumb = new Swiper(".swiper-thumnail", {
            slidesPerView: "auto",

            //wide表示ではverticalに
            breakpoints: {
                769: {
                    direction: "vertical",
                },
            },
        });

        const swiper = new Swiper(".slide", {
            // Optional parameters
            loop: true,
            thumbs: {
                swiper: thumb,
            },
        });
    }
}
